import { render, staticRenderFns } from "./AdminCustomersScreen.vue?vue&type=template&id=a92cd0a6&scoped=true&"
import script from "./AdminCustomersScreen.vue?vue&type=script&lang=js&"
export * from "./AdminCustomersScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92cd0a6",
  null
  
)

export default component.exports